var _path, _path2, _circle, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotifBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 32,
    viewBox: "0 0 29 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1495 17.3095C17.1495 15.8674 16.5767 14.4845 15.557 13.4648C14.5373 12.4452 13.1544 11.8723 11.7124 11.8723C10.2703 11.8723 8.88738 12.4452 7.86771 13.4648C6.84805 14.4845 6.27521 15.8674 6.27521 17.3095C6.27521 23.6528 3.55664 25.4652 3.55664 25.4652H19.8681C19.8681 25.4652 17.1495 23.6528 17.1495 17.3095Z",
    stroke: "#637381",
    strokeWidth: 1.35929,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2799 29.0901C13.1206 29.3647 12.892 29.5927 12.6168 29.7512C12.3417 29.9097 12.0298 29.9931 11.7122 29.9931C11.3947 29.9931 11.0828 29.9097 10.8077 29.7512C10.5325 29.5927 10.3038 29.3647 10.1445 29.0901",
    stroke: "#637381",
    strokeWidth: 1.35929,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.8681,
    cy: 8.70064,
    r: 8.15571,
    fill: "#DC3545"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5367 11.9043V10.3139H16.3161V9.06611L20.3287 3.3408H22.1026V8.95601H23.2281V10.3139H22.1026V11.9043H20.5367ZM17.9921 8.95601H20.6345V5.06573L17.9921 8.95601Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifBell);
export default __webpack_public_path__ + "static/media/notifBell.f9e0882b549d496d43258aec9c3480b6.svg";
export { ForwardRef as ReactComponent };